import { RoleEnum } from '@enum/role.enum';
import { RoleNames } from '@util/constants/role-names';

export const accountTeamRoleList = [
  { label: RoleNames[RoleEnum.Admin], value: RoleEnum.Admin },
  { label: RoleNames[RoleEnum.Developer], value: RoleEnum.Developer },
  { label: RoleNames[RoleEnum.User], value: RoleEnum.User },
];
